<ng-container *ngIf="countrySelectOptions$ | async as countryOptions; else loading">
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.COUNTRY' | translate }}
    </glxy-label>
    <mat-select [formControl]="countryOptionControl" required="true">
      <mat-option *ngFor="let option of countryOptions" [value]="option.value">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</ng-container>
<ng-container *ngIf="countryOptionControl.value !== ''">
  <ng-container *ngIf="stateSelectOptions$ | async as stateOptions">
    <ng-container *ngIf="stateOptions.length > 1">
      <ng-container *ngIf="!loadingStates; else loading">
        <glxy-form-field required="true">
          <glxy-label>
            {{ countryZone$ | async }}
          </glxy-label>
          <mat-select [formControl]="stateOptionControl" required="true">
            <mat-option *ngFor="let option of stateOptions" [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<glxy-form-field>
  <glxy-label>{{ 'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.CITY' | translate }}</glxy-label>
  <input
    matInput
    [formControl]="cityControl"
    [placeholder]="'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.ANY_CITY' | translate"
  />
</glxy-form-field>
<glxy-form-field>
  <glxy-label>{{ 'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.ZIP_CODE' | translate }}</glxy-label>
  <input
    matInput
    [formControl]="zipCodeControl"
    [placeholder]="'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.ANY_ZIP_CODE' | translate"
  />
</glxy-form-field>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
